import * as Inovx from '@shared';
import EntitlementConstants from '../constants/EntitlementConstants';
import EntitlementServices from '../services/EntitlementServices';
import EntitlementStore from '../stores/EntitlementStore';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;

declare var InovxLoader: any;

function receiveEntitlementData(data: any): void {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: EntitlementConstants.ENTITLEMENT_RECIEVE_DATA,
        data: data
    });
}

function receiveSettingsData(data: IEntitlementSettings) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: EntitlementConstants.ENTITLEMENT_RECIEVE_SETTINGS_DATA,
        data: data
    });
}

function receiveHint(data: IExternalGroup[], callback: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: EntitlementConstants.ENTITLEMENT_RECEIVE_SEARCH_HINT,
        data: data,
        callback: callback
    });
}

function _finishEdit() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: EntitlementConstants.ENTITLEMENT_FINISH_EDIT
    });
}

function sendInvalidSave() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: EntitlementConstants.ENTITLEMENT_FORM_INVALID_SAVE
    });
}

var EntitlementActions = {

    getAllEntitlement(callback?: any, errorCallback?: IErrorCallback, ignoreDefaultError?: boolean): void {
        EntitlementServices.getAll(function (data) {
            if (callback !== 'undefined' && callback != null) {
                callback(data);
            }
            receiveEntitlementData(data);
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        },
        ignoreDefaultError);
    },

    getSettings(callback?: (data: IEntitlementSettings) => void, errorCallback?: IErrorCallback) {
        EntitlementServices.getSettings((settings) => {
            callback?.(settings);
            receiveSettingsData(settings);
        }, (error) => {
            errorCallback?.(error);
        }, true);
    },

    beginAdd(isLinkedGroup: boolean): void {
        EntitlementServices.getApplicationPermissions(
            function (data) {
                Inovx.Shared.Flux.AppDispatcher.dispatch({
                    actionType: EntitlementConstants.ENTITLEMENT_BEGIN_ADD,
                    applicationPermissions: data,
                    isLinkedGroup: isLinkedGroup
                });
            }, function (error) {
            }
        );
    },
    createEntitlement(callback?: any): void {
        if (EntitlementStore.getIsValidObject(EntitlementConstants.ENTITLEMENT_ADD_FORM)) {
            if (!SystemStore.isActionInProgress(EntitlementConstants.ENTITLEMENT_ADD)) {
                SystemActions.beginAction(EntitlementConstants.ENTITLEMENT_ADD);

                var securityGroup = EntitlementStore.getSecurityGroup();
                var securityGroupDetail = EntitlementStore.getSecurityGroupDetail();
                var applicationPermissions = securityGroupDetail.ApplicationPermissions;
                var groupUsers = securityGroupDetail.GroupUsers;
                var externalGroups = securityGroupDetail.LinkedExternalGroups;

                var permissionIDs: string[] = [];
                var groupUserIDs: string[] = [];
                var externalGroupIDs: string[] = [];

                for (var index in applicationPermissions) {
                    var applicationPermission = applicationPermissions[index];

                    for (var subIndex in applicationPermission.Permissions) {
                        var permission = applicationPermission.Permissions[subIndex];
                        if (permission.Assigned) {
                            permissionIDs.push(permission.ID);
                        }
                    }
                }

                for (var index in groupUsers) {
                    var groupUser = groupUsers[index];
                    groupUserIDs.push(groupUser.UserID);
                }

                for (var index in externalGroups) {
                    var group = externalGroups[index];
                    externalGroupIDs.push(group.ID);
                }

                EntitlementServices.create(securityGroup, permissionIDs, groupUserIDs, externalGroupIDs,
                    function () {
                        EntitlementActions.refreshData();
                        if (callback !== undefined && callback != null) {
                            callback();
                        }

                        _finishEdit();
                        SystemActions.endAction(EntitlementConstants.ENTITLEMENT_ADD);
                    },
                    function () {
                        SystemActions.endAction(EntitlementConstants.ENTITLEMENT_ADD);
                    });
            }
        } else {
            sendInvalidSave();
        }
    },

    beginEdit(securityGroup: any): void {
        EntitlementServices.getDetail(securityGroup.ID,
            function (data) {
                Inovx.Shared.Flux.AppDispatcher.dispatch({
                    actionType: EntitlementConstants.ENTITLEMENT_BEGIN_EDIT,
                    securityGroup: securityGroup,
                    securityGroupDetail: data
                });
            }, function (error) {
            });
    },

    updateEntitlement(callback?: any): void {
        if (EntitlementStore.getIsValidObject(EntitlementConstants.ENTITLEMENT_ADD_FORM)) {

            if (!EntitlementStore.getIsValidEditObject()) {
                EntitlementActions.displayInvalidEdit();
                sendInvalidSave();
            } else {
                if (!SystemStore.isActionInProgress(EntitlementConstants.ENTITLEMENT_EDIT)) {
                    SystemActions.beginAction(EntitlementConstants.ENTITLEMENT_EDIT);

                    var securityGroup = EntitlementStore.getSecurityGroup();
                    var securityGroupDetail = EntitlementStore.getSecurityGroupDetail();
                    var applicationPermissions = securityGroupDetail.ApplicationPermissions;
                    var groupUsers = securityGroupDetail.GroupUsers;
                    var externalGroups = securityGroupDetail.LinkedExternalGroups;

                    var permissionIDs: string[] = [];
                    var groupUserIDs: string[] = [];
                    var externalGroupIDs: string[] = [];

                    for (var index in applicationPermissions) {
                        var applicationPermission = applicationPermissions[index];

                        for (var subIndex in applicationPermission.Permissions) {
                            var permission = applicationPermission.Permissions[subIndex];
                            if (permission.Assigned) {
                                permissionIDs.push(permission.ID);
                            }
                        }
                    }

                    for (var index in groupUsers) {
                        var groupUser = groupUsers[index];
                        groupUserIDs.push(groupUser.UserID);
                    }

                    for (var index in externalGroups) {
                        var group = externalGroups[index];
                        externalGroupIDs.push(group.ID);
                    }

                    EntitlementServices.update(securityGroup, permissionIDs, groupUserIDs, externalGroupIDs,
                        function (data) {
                            EntitlementActions.refreshData();
                            if (callback !== undefined && callback != null) {
                                callback();
                            }
                            _finishEdit();
                            SystemActions.endAction(EntitlementConstants.ENTITLEMENT_EDIT);
                        },
                        function (error) {
                            SystemActions.endAction(EntitlementConstants.ENTITLEMENT_EDIT);
                        });
                }
            }
        } else {
            sendInvalidSave();
        }
    },

    finishEdit(): void {
        if (EntitlementStore.getHasChanges()) {
            var saveFunct = EntitlementStore.getIsEditing() ? EntitlementActions.updateEntitlement : EntitlementActions.createEntitlement;
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                cancelCallback: _finishEdit,
                confirmCallback: saveFunct
            });
        } else {
            _finishEdit();
        }
    },

    deleteEntitlement(securityGroup: ISecurityGroup, callback: any): void {
        if (!SystemStore.isActionInProgress(EntitlementConstants.ENTITLEMENT_DELETE)) {
            SystemActions.beginAction(EntitlementConstants.ENTITLEMENT_DELETE);

            EntitlementServices.delete(securityGroup,
                function () {
                    EntitlementActions.refreshData();
                    if (callback !== 'undefined' && callback != null) {
                        callback();
                    }
                    SystemActions.endAction(EntitlementConstants.ENTITLEMENT_DELETE);
                },
                function (error) {
                    SystemActions.endAction(EntitlementConstants.ENTITLEMENT_DELETE);
                });
        }
    },

    refreshData() {
        this.getAllEntitlement();
    },

    editSecurityGroup(comp: string, key: string, value: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: EntitlementConstants.ENTITLEMENT_UPDATE_SECURITY_GROUP,
            component: comp,
            key: key,
            value: value
        });
    },

    editPermissions(uid: string, value: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: EntitlementConstants.ENTITLEMENT_UPDATE_PERMISSIONS,
            uid: uid,
            value: value
        });
    },

    addUsers(users: IUser[]) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: EntitlementConstants.ENTITLEMENT_ADD_USER,
            users: users
        });
    },

    deleteUser(user: IUser) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: EntitlementConstants.ENTITLEMENT_DELETE_USER,
            user: user
        });
    },

    addExternalGroup(externalGroup: IExternalGroup) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: EntitlementConstants.ENTITLEMENT_ADD_EXTERNAL_GROUP,
            externalGroup: externalGroup
        });
    },

    deleteExternalGroup(externalGroup: IExternalGroup) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: EntitlementConstants.ENTITLEMENT_DELETE_EXTERNAL_GROUP,
            externalGroup: externalGroup
        });
    },

    displayInvalidEdit() {
        var messageObject = {
            message: InovxLoader.t('Entitlement:message.systemSecurityGroupUserNotFound')
        };
        SystemActions.displayErrorMessage(messageObject);
    },

    getSearchGroup(hint: string, callback: any) {
        if (!SystemStore.isActionInProgress(EntitlementConstants.ENTITLEMENT_DIRECTORY_GROUP_SEARCH)) {
            SystemActions.beginAction(EntitlementConstants.ENTITLEMENT_DIRECTORY_GROUP_SEARCH);

            EntitlementServices.searchGroup(hint,
                function (data) {
                    receiveHint(data, callback);
                    SystemActions.endAction(EntitlementConstants.ENTITLEMENT_DIRECTORY_GROUP_SEARCH);
                },
                function (error) {
                    SystemActions.endAction(EntitlementConstants.ENTITLEMENT_DIRECTORY_GROUP_SEARCH);
                });
        }
    },
    checkFacilityPermission() {
        const applicationPermissions = EntitlementStore.getSecurityGroupDetail().ApplicationPermissions;
        const facilityApp = applicationPermissions.find(
            app => app.ApplicationDisplayName === "Facility Explorer"
        );

        if (!facilityApp) return true;

        const facilityPermissions = facilityApp.Permissions ?? [];

        const useFacilityPermission = facilityPermissions.find(
            p => p.DisplayName === "Use Facility Explorer"
        );

        const hasOtherAssignedPermissions = facilityPermissions.some(
            p => p.DisplayName !== "Use Facility Explorer" && p.Assigned === true
        );

        if (hasOtherAssignedPermissions && !useFacilityPermission?.Assigned) {
            return false;
        }

        return true;
    }
};

export default EntitlementActions;
